import React from 'react';
import {BUYERS, TEAM} from "../../consts/tables";
import Alert from "../Alert";
import {getData, manageData} from "../../requests/CRUD";
import {addSpaceAfterComma, capitalizeAll, formatName, formatNames, formatType} from "../../utils";
import {sendBuyerEmail} from "../../requests/emailRequests";
import {dateUStoISO, dateToString} from "../../date-converter";
import BuyerForm from "../BuyerForm/BuyerForm";
import {url} from "../../consts/env";
import { ApolloConsumer } from '@apollo/client';
import { CREATE_UPDATE_BUYER } from '../Graphql/mutations';
import { GET_ALL_TEAM_MEMBERS_DATA, GET_TEAMMEMBER_StRIVE_FEES } from '../Graphql/Queries/StriveFeesQuery';
import { GET_CONTACT_TEAM_BY_ID, GET_CONTACT_TEAM_LIST_QUERY } from '../Graphql/ContactsQueries/contactsQuery';
import { fetchData, mutateData } from '../Service/graphQlService';
import { CREATE_OR_UPDATE_CONTACTS_BUYERS, CREATE_OR_UPDATE_CONTACTS_INVESTORS } from '../Graphql/ContactsMutations/allContactsMutation';
import InvestorForm from '../InvestorForm/InvestorForm';
import { SEND_EMAIL_NOTIFICATION } from '../Graphql/MailQueries/sendEmalNotification';
import { DEFAULT_INVESTOR_STATUS, STATUS_1031_BUYER, STATUS_ACTIVE_INVESTOR } from '../../investor-status';


const dateProps = [
    'LAST_MODIFIED',
];

function convertFormToData(formData) {
    const data = {...formData};
    dateProps.filter(key => data[key]).forEach(key => {
        const str = dateUStoISO(data[key]);
        if (str !== false) {
            data[key] = str;
        }
    });
    return data;
}

export default class InvestorDrawer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: { status: DEFAULT_INVESTOR_STATUS },
            paneIndex: 0,
            isBusy: null,
            error: null,
        };
        this.client = null;
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleDropdownChange = this.handleDropdownChange.bind(this);
        this.saveData = this.saveData.bind(this);
    }

    componentDidUpdate(prevProps){
        if(prevProps.resetDrawer !== this.props.resetDrawer && this.props.resetDrawer === true)
            this.setState({data: { status: DEFAULT_INVESTOR_STATUS }});
    }

    handleSubmit(e) {
        e.preventDefault();
        //consition added newly
        if(this.client){
        this.saveData(this.client);
        }
    }

    handleChange(key, value) {
        const data = {...this.state.data};
        data[key] = value;
        this.setState({data});
    }

    handleDropdownChange(query, queryType, x, key) {
        const data = {...this.state.data};
        if (key === 'status') {
            // Default the down-leg date to today when 1031 Buyer is picked
            // (adjustable via the date picker); clear it for other statuses
            // since the drawer only creates new records.
            data.date_of_down_leg = query[key] === STATUS_1031_BUYER
                ? dateToString(new Date())
                : null;
        }
        if (key === 'STATUS') {
            data.LAST_MODIFIED = new Date().toLocaleDateString("en-US");
            if (!query[key]) {
                data.CATEGORY = null;
                data.TYPE = null;
                data.SINGLE_TENANT_SUBCATEGORY = null;
                data.MULTI_TENANT_SUBCATEGORY = null;
                data.MARKET = null;
                data.PRICE_MIN = null;
                data.PRICE_MAX = null;
                data.CAP_RATE_MIN = null;
                data.CAP_RATE_MAX = null;
                data.STRIVE_AGENT = null;
            }
        }
        data[key] = query[key];
        this.setState({data});
    }

    saveData(client) {
        if (this.state.isBusy) return;

        this.setState({
            isBusy: true,
            error: null,
        });

        Object.keys(this.state.data).forEach(k => {
            if (!this.state.data[k] || k === 'undefined') {
                const newData = {...this.state.data};
                delete newData[k];
                this.setState({data: newData})
            }
        });
        const token = localStorage.getItem('authToken');
        const payload = {};

        // List of fields to include in the payload
        const fields = [
            "first_name",
            "last_name",
            "phone",
            "email",
            "profile",
            "status",
            "notes",
            "company_name",
            "company_address",
            "company_city",
            "company_state",
            "company_zip",
            "date_of_down_leg"
        ];

        // Dynamically add fields to the payload if they exist in `this.state.data`
        fields.forEach(field => {
            if (this.state.data[field]) { // Add only if the field exists and is truthy
                payload[field] = this.state.data[field];
            }
        });
        if (payload.date_of_down_leg) {
            const isoDate = dateUStoISO(payload.date_of_down_leg);
            if (isoDate !== false) payload.date_of_down_leg = isoDate;
        }
        // The form's Notes field is a plain textarea, but the API expects
        // [ContactNotesInput] - wrap the text so the save isn't rejected.
        if (typeof payload.notes === 'string') {
            payload.notes = payload.notes.trim() ? [{text: payload.notes.trim()}] : [];
        }
        payload.contact_type = "Investor";
        //using condition based teammember url because wedont have single api which can take rowid and give single data,if there is no id need to give entire list
        // const TeamQuery = this.state.data.STRIVE_AGENT ? GET_TEAMMEMBER_StRIVE_FEES : GET_ALL_TEAM_MEMBERS_DATA;
        // const teamVariableData = this.state.data.STRIVE_AGENT ? {arcimedesRowId :this.state.data.STRIVE_AGENT} : {filters:[]}

        // const TeamQuery = this.state.data.STRIVE_AGENT ? GET_CONTACT_TEAM_BY_ID : GET_CONTACT_TEAM_LIST_QUERY;
        // const teamVariableData = this.state.data.STRIVE_AGENT ? {contactid : Number(this.state.data.STRIVE_AGENT)} : {filters:[],type:"Team",}
        Promise.all([
            // manageData({
            //     tableCode: BUYERS,
            //     data: [convertFormToData(this.state.data)],
            // }),
            // getData({
            //     tableCode: TEAM,
            //     options: {
            //         column: [
            //             'FIRST_NAME',
            //             'LAST_NAME',
            //         ],
            //         filter: [{
            //             'text': this.state.data.STRIVE_AGENT ? this.state.data.STRIVE_AGENT : '',
            //             'code': 'ARCIMEDES_ROW_ID',
            //             'type': 'exact',
            //         }],
            //     }
            // })
       mutateData(CREATE_OR_UPDATE_CONTACTS_INVESTORS,  {
                          input :payload
                       },),
            // this.client.query({
            //     query: CREATE_UPDATE_BUYER, variables: {input: payload }, fetchPolicy: "no-cache",
            //     // query: GET_AGENTS, variables:{pageOptions: pageParams},fetchPolicy: "no-cache",
            //     context: {
            //         headers: {
            //             authorization: `Bearer ${token}`, // Bearer token added here
            //         },
            //     },
            // }),
            //added same as it is in the investor create update 
             fetchData(GET_CONTACT_TEAM_BY_ID, {
                      contactid: this.state.data.strive_agent
                        ? Number(this.state.data.strive_agent)
                        : null,
                    }),
            //fetchData(TeamQuery, {type:"Team",pageOptions: pageParams, filters: filterOptions, sortOptions: sortOptions })
            // this.client.query({
            //     query: TeamQuery,
            //     variables: teamVariableData,
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     },
            //   }),
        ]).then(res => {
            //if (res && res[0] && res[0].success && res[1] && res[1].success) {
            if (res && res[0] && res[0].data.createOrUpdateContact.success && res[1] && res[1].data) {
                this.setState({isBusy: false});
                //this.props.savedNewItem(res[0].data[0]);
                this.props.savedNewItem(res[0].data.createOrUpdateContact.contact);

                if (this.props.closeDrawer) {
                    this.props.closeDrawer();
                    setTimeout(() => this.setState({data: {}}));
                }
            } else {
                this.setState({
                    isBusy: null,
                    //error: res && res[0] && res[0].message ? res[0].message : 'Unspecified error',
                    error: res && res[0] && res[0].data.createOrUpdateContact.error ? res[0].data.createOrUpdateContact.error : 'Unspecified error',
                });
            }
            // return {
            //     success: res[0].success && res[1].success,
            //     STATUS: res[0].data[0].STATUS,
            //     CATEGORY: capitalizeAll(res[0].data[0].CATEGORY),
            //     TYPE: formatType(res[0].data[0].TYPE),
            //     MARKET: capitalizeAll(res[0].data[0].MARKET),
            //     TENANT_SUBCATEGORY: res[0].data[0].TYPE === 'MT' ? addSpaceAfterComma(res[0].data[0].MULTI_TENANT_SUBCATEGORY) : res[0].data[0].TYPE === 'STNL' ? addSpaceAfterComma(res[0].data[0].SINGLE_TENANT_SUBCATEGORY) : null,
            //     PRICE_MIN: res[0].data[0].PRICE_MIN,
            //     PRICE_MAX: res[0].data[0].PRICE_MAX,
            //     CAP_RATE_MIN: res[0].data[0].CAP_RATE_MIN,
            //     CAP_RATE_MAX: res[0].data[0].CAP_RATE_MAX,
            //     NOTES: res[0].data[0].NOTES,
            //     STRIVE_AGENT: res[1].data.length ? formatName(res[1].data[0]) : null,
            //     LINK: `${url}buyers?FIRST_NAME=${res[0].data[0].FIRST_NAME}&LAST_NAME=${res[0].data[0].LAST_NAME}`
            // }

            return {
                success: res[0].data.createOrUpdateContact.success && res[1].data,
                status: res[0].data.createOrUpdateContact.contact.status,
                category: capitalizeAll(res[0].data.createOrUpdateContact.contact.category),
                type: formatType(res[0].data.createOrUpdateContact.contact.type),
                market: capitalizeAll(res[0].data.createOrUpdateContact.contact.market),
                tenant_subcategory: res[0].data.createOrUpdateContact.contact.type === 'MT' ? addSpaceAfterComma(res[0].data.createOrUpdateContact.contact.multi_tenant_subcategory) : res[0].data.createOrUpdateContact.contact.type === 'STNL' ? addSpaceAfterComma(res[0].data.createOrUpdateContact.contact.single_tenant_subcategory) : null,
                price_min: res[0].data.createOrUpdateContact.contact.price_min,
                price_max: res[0].data.createOrUpdateContact.contact.price_max,
                cap_rate_min: res[0].data.createOrUpdateContact.contact.cap_rate_min,
                cap_rate_max: res[0].data.createOrUpdateContact.contact.cap_rate_max,
                notes: res[0].data.createOrUpdateContact.contact.notes,
                // STRIVE_AGENT: this.state.data.STRIVE_AGENT ? this.getStriveAgentValue(res[1].data.getTeamMember) : this.getStriveAgentValue(res[1].data.getAllTeamMembers[0]),
                strive_agent: this.state.data.strive_agent ? this.getStriveAgentValue(res[1].data.getContactByContactid.contact) : null,
                LINK: `${url}investor?first_name=${res[0].data.createOrUpdateContact.contact.first_name}&last_name=${res[0].data.createOrUpdateContact.contact.last_name}`
            }
        }).then(res => {    
            if (res.success && res.status === STATUS_1031_BUYER){
                mutateData(SEND_EMAIL_NOTIFICATION, { input: { data: res, type: 'buyer-status-email' } })
            }
            if (res.success && res.status === STATUS_ACTIVE_INVESTOR){
                mutateData(SEND_EMAIL_NOTIFICATION, { input: { data: res, type: 'buyer-status-email' } })
            }
        });
    }
    getStriveAgentValue(data) {
        if (data) {
            return formatNames(data);
        }
        return null;
    }
    render() {
        const data = this.state.data;

        return (
            <ApolloConsumer>
            {client => {
                if (!this.client) {
                    this.client = client;
                }
                return (
            <div>
                <InvestorForm data={data}
                           paneIndex={this.state.paneIndex}
                           handleSubmit={this.handleSubmit}
                           handleCancel={this.props.closeDrawer}
                           handleParentChange={this.handleChange}
                           handleParentDropdownChange={this.handleDropdownChange}
                           handlePaneChange={(key) => this.setState({paneIndex: key})}/>
                {this.state.error && <Alert type='error'>{this.state.error}</Alert>}
            </div>
            )
        }}

    </ApolloConsumer>
        )
    }
}